import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { BaseLanguageTranslationProps } from './types';
import { useTranslation } from 'react-i18next';
import { getLanguageDisplayName } from './utils';
import { TranslationReviewPanel } from './TranslationReviewPanel';

export const BaseLanguageTranslation: React.FC<BaseLanguageTranslationProps> = ({
  translation,
  product,
  onCopyText,
  onViewHistory,
  onEditTranslation,
}) => {
  const { t } = useTranslation();

  return (
    <Box mb={3}>
      <Stack spacing={0.5} mb={1.5}>
        <Typography variant="h6" fontWeight={700}>
          {t('productDetails.baseLanguageTitle', { language: getLanguageDisplayName(product.base_language || 'en') })}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {t('productDetails.baseLanguageDescription')}
        </Typography>
      </Stack>

      <TranslationReviewPanel
        translation={translation}
        productId={product.id}
        isBase
        onCopyText={onCopyText}
        onViewHistory={onViewHistory}
        onEditTranslation={onEditTranslation}
      />
    </Box>
  );
};

